import {
  LineDiscount,
  OrderLine,
  POLine,
  PoOrderDetailsResponse,
} from '@zonofi/zono-money-store';
import { DiscountType, OrderProductActionType } from '../../constants';

export const patchOrderLines = (
  responseData: any,
  setData: React.Dispatch<
    React.SetStateAction<PoOrderDetailsResponse | undefined>
  >,
  type?: OrderProductActionType
) => {
  if (responseData?.orderLines && responseData?.order) {
    setData((prevData) => {
      if (!prevData) return prevData;
      const updatedOrder = responseData.order;

      return {
        ...prevData,
        total: updatedOrder.total ?? prevData.total,
        skuCount: updatedOrder.skuCount ?? prevData.skuCount,
        refOrderNumber: updatedOrder.refOrderNumber ?? prevData.refOrderNumber,
        lines: updateOrderLine(prevData.lines, responseData.orderLines, type),
      };
    });
  }
};

const updateOrderLine = (
  existingLines: POLine[],
  updatedOrderLines: OrderLine[],
  type?: OrderProductActionType
): POLine[] => {
  return existingLines.map((line) => {
    const matched = updatedOrderLines.find(
      (updated) => updated.productVariantId === line.productVariantId
    );

    if (matched) {
      if (type === OrderProductActionType.EDIT) {
        return {
          ...line,
          unitPrice: matched.unitPrice ?? line.unitPrice,
          quantity: matched.quantity ?? line.quantity,
          linePrice: matched.linePrice ?? line.linePrice,
          ...(matched?.discount && matched?.discountType
            ? {
                lineDiscount: {
                  discount: String(matched.discount),
                  discountType: matched.discountType as DiscountType,
                },
              }
            : {}),
        };
      } else if (type === OrderProductActionType.REMOVE) {
        return {
          ...line,
          lineDiscount: {} as LineDiscount,
          unitPrice: matched.unitPrice ?? line.unitPrice,
          quantity: matched.quantity ?? line.quantity,
          linePrice: matched.linePrice ?? line.linePrice,
        };
      }
    }

    return line;
  });
};
